/* eslint-disable no-unused-vars */
import { authService } from '@/services';
import store from '@/store/store';
import Vue from 'vue';
import Router from 'vue-router';
import RouterPrefetch from 'vue-router-prefetch';

const Home = () => import(/* webpackChunkName: "Home" */ '@/views/Home.vue');
const Login = () => import(/* webpackChunkName: "Login" */ '@/views/Login.vue');
const LostPassword = () => import(/* webpackChunkName: "LostPassword" */ '@/views/LostPassword.vue');
const ResetPassword = () => import(/* webpackChunkName: "ResetPassword" */ '@/views/ResetPassword.vue');
const Token = () => import(/* webpackChunkName: "Token" */ '@/views/Token.vue');
const Classi = () => import(/* webpackChunkName: "Classi" */ '@/views/Classi.vue');
const Profile = () => import(/* webpackChunkName: "Profile" */ '@/views/Profile.vue');
const ProfileEdit = () => import(/* webpackChunkName: "ProfileEdit" */ '@/views/ProfileEdit.vue');
const MinoreDettaglio = () => import(/* webpackChunkName: "MinoreDettaglio" */ '@/views/MinoreDettaglio.vue');
const MinoreDettaglioEdit = () => import(/* webpackChunkName: "MinoreDettaglioEdit" */ '@/views/MinoreDettaglioEdit.vue');
const GenitoreClasseDettaglio = () => import(/* webpackChunkName: "GenitoreClasseDettaglio" */ '@/views/GenitoreClasseDettaglio.vue');
const ListaBambini = () => import(/* webpackChunkName: "ListaBambini" */ '@/views/ListaBambini.vue');
const Insegnanti = () => import(/* webpackChunkName: "Insegnanti" */ '@/views/Insegnanti.vue');
const MinoreCalendar = () => import(/* webpackChunkName: "MinoreCalendar" */ '@/views/MinoreCalendar.vue');
const Genitori = () => import(/* webpackChunkName: "Genitori" */ '@/views/Genitori.vue');
const GenitoriAdd = () => import(/* webpackChunkName: "GenitoriAdd" */ '@/views/GenitoriAdd.vue');
const GenitoriNew = () => import(/* webpackChunkName: "GenitoriNew" */ '@/views/GenitoriNew.vue');
const GenitoriAssociate = () => import(/* webpackChunkName: "GenitoriAssociate" */ '@/views/GenitoriAssociate.vue');
const FamiliareDetail = () => import(/* webpackChunkName: "FamiliareDetail" */ '@/views/FamiliareDetail.vue');
const Contacts = () => import(/* webpackChunkName: "Contacts" */ '@/views/Contacts.vue');
const QrCode = () => import(/* webpackChunkName: "QrCode" */ '@/views/QrCode.vue');
const QrCodeSuccess = () => import(/* webpackChunkName: "QrCodeSuccess" */ '@/views/QrCodeSuccess.vue');
const Register = () => import(/* webpackChunkName: "Register" */ '@/views/Register.vue');
const Communication = () => import(/* webpackChunkName: "Communication" */ '@/views/Communication.vue');
const FullEmail = () => import(/* webpackChunkName: "FullEmail" */ '@/views/FullEmail.vue');
const CreateCommunication = () => import(/* webpackChunkName: "CreateCommunication" */ '@/views/CreateCommunication.vue');
const CommunicationReceivers = () => import(/* webpackChunkName: "CommunicationReceivers" */ '@/views/CommunicationReceivers.vue');
const ScheduledAbsence = () => import(/* webpackChunkName: "ScheduledAbsence" */ '@/views/ScheduledAbsence.vue');

Vue.use(Router);
Vue.use(RouterPrefetch);

const router = new Router({
  base: process.env.BASE_URL,
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  },
  routes: [{
    path: '/home',
    name: 'Home',
    component: Home,
    meta: {
      auth: true,
      roles: ['tutor'],
    },
  },
  {
    path: '/insegnanti/:classeId?',
    name: 'Insegnanti',
    props: true,
    component: Insegnanti,
    meta: {
      auth: true,
      roles: ['teacher'],
    },
  },
  {
    path: '/lista/:id?',
    name: 'ListaBambini',
    props: true,
    component: ListaBambini,
    meta: {
      auth: true,
      roles: ['teacher'],
    },
  },
  {
    path: '/classi',
    name: 'Classi',
    component: Classi,
    meta: {
      auth: true,
      roles: ['teacher'],
    },
  },
  {
    path: '/profilo',
    name: 'Profilo',
    component: Profile,
    meta: {
      auth: true,
    },
  },
  {
    path: '/profilo/edit',
    name: 'ProfileEdit',
    component: ProfileEdit,
    meta: {
      auth: true,
    },
  },
  {
    path: '/genitore/classe/:id',
    name: 'GenitoreClasseDettaglio',
    component: GenitoreClasseDettaglio,
    props: true,
    meta: {
      auth: true,
      roles: ['tutor'],
    },
  },
  {
    path: '/minore/:id',
    name: 'MinoreDettaglio',
    component: MinoreDettaglio,
    props: true,
    meta: {
      auth: true,
    },
  },
  {
    path: '/minore/edit/:id',
    name: 'MinoreDettaglioEdit',
    component: MinoreDettaglioEdit,
    props: true,
    meta: {
      auth: true,
      roles: ['tutor'],
    },
  },
  {
    path: '/contacts/:id',
    name: 'Contacts',
    component: Contacts,
    props: true,
    meta: {
      auth: true,
    },
  },
  {
    path: '/minore/calendar/:id',
    name: 'MinoreCalendar',
    component: MinoreCalendar,
    props: true,
    meta: {
      auth: true,
      roles: ['tutor'],
    },
  },
  {
    path: '/minore/genitori/:id',
    name: 'Genitori',
    component: Genitori,
    props: true,
    meta: {
      auth: true,
      roles: ['tutor'],
    },
  },
  {
    path: '/minore/genitori/:id/add',
    name: 'GenitoriAdd',
    component: GenitoriAdd,
    props: true,
    meta: {
      auth: true,
      roles: ['tutor'],
    },
  },
  {
    path: '/minore/genitori/:id/new/:cf',
    name: 'GenitoriNew',
    component: GenitoriNew,
    props: true,
    meta: {
      auth: true,
      roles: ['tutor'],
    },
  },
  {
    path: '/minore/genitori/:id/associate',
    name: 'GenitoriAssociate',
    component: GenitoriAssociate,
    props: true,
    meta: {
      auth: true,
      roles: ['tutor'],
    },
  },
  {
    path: '/minore/genitori/:id/dettaglio/:genitore',
    name: 'FamiliareDetail',
    component: FamiliareDetail,
    props: true,
    meta: {
      auth: true,
    },
  },
  {
    path: '/lost-password',
    component: LostPassword,
    name: 'LostPassword',
    props: true,
  },
  {
    path: '/reset-password',
    component: ResetPassword,
    name: 'ResetPassword',
    props: true,
  },
  {
    path: '/confirm',
    component: Token,
    name: 'Token',
    props: true,
  },
  {
    path: '/qrcode/:id',
    component: QrCode,
    name: 'QrCode',
    props: true,
    meta: {
      auth: true,
      roles: ['tutor'],
    },
  },
  {
    path: '/qr-success',
    component: QrCodeSuccess,
    name: 'QrCodeSuccess',
    props: true,
    meta: {
      auth: true,
      roles: ['tutor'],
    },
  },
  {
    path: '/absence/:id',
    component: ScheduledAbsence,
    name: 'ScheduledAbsence',
    props: true,
    meta: {
      auth: true,
      roles: ['tutor'],
    },
  },
  {
    path: '/register/:id',
    component: Register,
    name: 'Register',
    props: true,
    meta: {
      auth: true,
      roles: ['teacher'],
    },
  },
  {
    path: '/communication/:id',
    component: Communication,
    name: 'Communication',
    props: true,
    meta: {
      auth: true,
    },
  },
  {
    path: '/email/:id',
    component: FullEmail,
    name: 'FullEmail',
    props: true,
    meta: {
      auth: true,
    },
  },
  {
    path: '/create/email/:id',
    component: CreateCommunication,
    name: 'CreateCommunication',
    props: true,
    meta: {
      auth: true,
    },
  },
  {
    path: '/email/receivers/:id',
    component: CommunicationReceivers,
    name: 'CommunicationReceivers',
    props: true,
    meta: {
      auth: true,
    },
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
  },
  {
    path: '*',
    redirect: {
      name: 'Home',
    },
  },
  ],
});

router.beforeEach((to, from, next) => {
  if (to.name === 'Login') {
    next();
  } else {
    const authRequired = to.matched.some(route => route.meta.auth);
    const authed = authService.isAuthorized();
    for (let i = 1; i < 99999; i += 1) {
      window.clearInterval(i);
    }
    if (authRequired && !authed) {
      next('/login');
    }
    const allowedRoles = to.matched.reduce(
      (acc, route) => route.meta.roles,
      [],
    );
    if (!allowedRoles || authService.hasRoles(allowedRoles)) {
      next();
    } else {
      next('/login');
    }
  }
});

router.beforeResolve((to, from, next) => {
  if (store) {
    store.dispatch('isPageLoading', true, { root: true });
    if (to.name === 'Home' || to.name === 'Classi') {
      store.dispatch('setBackAction', false, { root: true });
    } else if (store.state.classi.all.items && store.state.classi.all.items.length === 1 && to.name === 'Insegnanti') {
      store.dispatch('setBackAction', false, { root: true });
    } else {
      store.dispatch('setBackAction', true, { root: true });
    }
    next();
  }
  next();
});

router.afterEach(() => {
  store.dispatch('isPageLoading', false, { root: true });
});

export default router;
